import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CardstatusComponent } from './components/card-status/cardstatus.component';
import { LockedoutComponent } from './components/lockedout/lockedout.component';
import { TimeoutComponent } from './components/timeout/timeout.component'
import { SendemailComponent } from './components/send-email/sendemail.component';
import { AuthGuard } from './services/guard/auth-guard.service';
import { ExceededTriesComponent } from "./components/exceeded-tries/exceeded-tries.component";
import { ErrorComponent } from "./components/error/error.component";
import {
  CardStatusExceededTriesComponent
} from "./components/card-status/card-status-exceeded-tries/card-status-exceeded-tries.component";
import { SendEmailSuccessComponent } from "./components/send-email/send-email-success/send-email-success.component";
import { ClioConstants } from "./models/clio-constants/clio-constants";
import { LoginCallbackComponent } from "./components/login-callback/login-callback.component";
import { loginCallbackGuard } from "./services/guard/login-callback.guard";
import { ErrorTemplateComponent } from "./components/error/error-template/error-template.component";

const routes: Routes = [
  { path: '', redirectTo: 'email', pathMatch: 'full' },
  {
    path: 'email',
    component: SendemailComponent,
    canActivate: [AuthGuard],
    title: ClioConstants.DRIVING_RECORD_INSURANCE_HISTORY
  },
  { path: 'email.html', redirectTo: 'email' },
  { path: 'lockedout', component: LockedoutComponent },
  { path: 'lockedout.html', redirectTo: 'lockedout' },
  {
    path: 'cardstatus',
    component: CardstatusComponent,
    title: ClioConstants.HAS_MY_CARD_BEEN_MAILED,
    canActivate: [AuthGuard]
  },
  { path: 'cardstatus.html', redirectTo: 'cardstatus' },
  { path: 'expired', component: TimeoutComponent },
  { path: 'expired.html', redirectTo: 'expired' },
  { path: 'exceededtries', component: ExceededTriesComponent },
  { path: 'exceededtries.html', redirectTo: 'exceededtries' },
  {
    path: 'statusexceededtries',
    component: CardStatusExceededTriesComponent,
    title: ClioConstants.HAS_MY_CARD_BEEN_MAILED
  },
  { path: 'statusexceededtries.html', redirectTo: 'statusexceededtries' },
  {
    path: 'error', component: ErrorComponent,
    children: [
      { path: '', redirectTo: 'record-not-found', pathMatch: 'full' },
      { path: 'record-not-found', component: ErrorTemplateComponent, data: { message: ClioConstants.NO_RECORDS_FOUND } },
      { path: 'documents-not-available', component: ErrorTemplateComponent, data: { message: ClioConstants.UNABLE_TO_PROVIDE_DOCUMENTS } },
      { path: 'request-not-completed', component: ErrorTemplateComponent, data: { message: ClioConstants.CANT_COMPLETE_REQUEST } },
      { path: 'status-not-found', component: ErrorTemplateComponent, data: { message: ClioConstants.NO_STATUS_FOUND } },
    ]
  },
  { path: 'error.html', redirectTo: 'error' },
  { path: 'sessionlocked', component: LockedoutComponent },
  { path: 'sessionlocked.html', redirectTo: 'sessionlocked' },
  { path: 'goodbye', component: SendEmailSuccessComponent },
  { path: 'goodbye.html', redirectTo: 'goodbye' },
  { path: "v1/oauth2/callback", component: LoginCallbackComponent, canActivate: [loginCallbackGuard] },
  { path: '**', redirectTo: 'error' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
